var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndoNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19866 -0.00050354L0.0556641 5.14351L5.19866 10.2865V6.0005H17.1987C18.5627 6.0005 19.8708 6.54235 20.8353 7.50685C21.7998 8.47135 22.3417 9.7795 22.3417 11.1435C22.3417 12.5075 21.7998 13.8157 20.8353 14.7802C19.8708 15.7447 18.5627 16.2865 17.1987 16.2865H12.0557V18.0005H17.1987C18.0991 18.0005 18.9908 17.8232 19.8227 17.4786C20.6547 17.134 21.4106 16.6289 22.0473 15.9921C22.684 15.3554 23.1891 14.5995 23.5337 13.7676C23.8783 12.9356 24.0557 12.044 24.0557 11.1435C24.0557 10.243 23.8783 9.35138 23.5337 8.51945C23.1891 7.68753 22.684 6.93161 22.0473 6.29488C21.4106 5.65814 20.6547 5.15305 19.8227 4.80846C18.9908 4.46386 18.0991 4.28651 17.1987 4.28651H5.19866V-0.00050354Z",
    fill: "#203662"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoNewIcon);
export default __webpack_public_path__ + "static/media/Undo-New-Icon.99dd6cd3bb2c21b1fb437345710482c3.svg";
export { ForwardRef as ReactComponent };